import PropTypes from 'prop-types';
import React from 'react';
import Classes from 'classnames';
import RenderComponentProto from '../../render-component-proto';
import Checkbox from 'core/gd-components/checkbox/checkbox.tsx';


class BooleanComponentProto extends RenderComponentProto {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this._bind('onChange');
    }

    render() {
        const classes = Classes('gd-field-boolean', this.props.renderMode, {
            'disabled': this.props.canEdit == false,
        });

        return (
            <div className={classes}>
                <div className="field-holder">
                    <Checkbox isChecked={this.state.value} disabled={this.props.canEdit==false} onClick={this.onChange} type="filled" />
                </div>
            </div>
        );
    }
}


BooleanComponentProto.propTypes = {
    id: PropTypes.string.isRequired,
    renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
    value: PropTypes.any,
    canEdit: PropTypes.bool,
    onChange: PropTypes.func,
};

BooleanComponentProto.defaultProps = {
    canEdit: false,
};

module.exports = BooleanComponentProto;